// removed by extract-text-webpack-plugin
module.exports = {"keyboard":"_37D-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/keyboard/index.less
// module id = 265
// module chunks = 0